import { LatLng, LatLngLiteral } from 'leaflet';

const distance = (a: LatLngLiteral, b: LatLngLiteral) =>
  Math.sqrt((a.lat - b.lat) ** 2 + (a.lng - b.lng) ** 2);

export const isBetween = (a: LatLng, b: LatLng, c: LatLng) => {
  return (
    Math.round(a.distanceTo(c) + b.distanceTo(c)) ===
    Math.round(a.distanceTo(b))
  );
};
